"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _createSvgIcon = _interopRequireDefault(require("./utils/createSvgIcon"));

var _default = (0, _createSvgIcon.default)( /*#__PURE__*/_react.default.createElement("path", {
  d: "M22.3188 10.7236 5.7836 1.1494c-.3822-.22-.8354-.1957-1.1985.0642-.363.2599-.5843.7186-.5851 1.2128V21.574c.0007.4943.222.9531.5851 1.2129.3631.2598.8165.2837 1.1985.0632l16.5352-9.5733c.4175-.2418.6812-.736.6812-1.2765 0-.5406-.2637-1.0347-.6812-1.2766Z"
}), 'Play');

exports.default = _default;